import RouterView from '@/page/main/DefaultRouterView'
import PayType from '@/page/pay/payType'
import PayList from '@/page/pay/list'
import PayCreate from '@/page/pay/createPayApproval'

export default {
  path: '/Pay',
  component: RouterView,
  children: [{
    path: 'Create/:projectId?',
    name: 'PayCreate',
    meta: {
      type: ['pay', 'create'],
      title: '新建款项支付'
    },
    component: PayCreate
  },{
    path: 'Type',
    meta: {
      type: ['pay', 'type'],
      title: '款项支付类型设置'
    },
    component: PayType
  },{
    path: 'List',
    meta: {
      type: ['pay', 'list'],
      title: '款项支付审批列表'
    },
    component: PayList
  },
  ]
}


// WEBPACK FOOTER //
// ./src/router/pay.js